import React from 'react';
import { Flex } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { ViewportList } from 'react-viewport-list';

import { selectedComponent } from '../../../redux/selectedComponentSlice';
import { firstIsUppercase } from '../../../utils/functions';
import PropsEditorRow from './PropsEditorRow';
import { scrollBarStyle } from '../../../utils/layoutConfig';
import debug from '../../../utils/debug';

function generateEditorList(component, list = [], circuitBreaker = 0) {
	if (circuitBreaker > 999_999) throw new Error('Circuit breaker disparado, verifique se não há um loop infinito');
	circuitBreaker++;

	if (!component) return list;

	const { componentId, props, blocks, childrenComponents, componentName, title } = component;
	//if aqui para colocar o elemento na ordem certa
	if (props) {
		list.push({
			componentId,
			componentName,
			title,
			props,
		});
	}
	childrenComponents?.forEach?.((childrenComponent) => generateEditorList(childrenComponent, list, circuitBreaker));
	blocks?.forEach?.((childrenComponent) => generateEditorList(childrenComponent, list, circuitBreaker));
	debug('childrenComponents', childrenComponents);
	debug('blocks', blocks);

	if (!props) return list;
	//Verificando Slots também
	Object.keys(props).forEach((key) => {
		if (props[key] && firstIsUppercase(key)) {
			generateEditorList(props[key], list, circuitBreaker);
			debug('props[key]', props[key]);
		}
	});

	return list;
}

const PropsEditorBody = () => {
	const [openList, setOpenList] = React.useState([]);
	const viewportRef = React.useRef(null);
	const [editorList, setEditorList] = React.useState([]);
	const { props: selectedComponentPropsValue, childComp } = useSelector(selectedComponent);

	React.useEffect(() => {
		const editors = generateEditorList(childComp ?? selectedComponentPropsValue);
		setEditorList(editors);
		if (!openList.length) {
			setOpenList(Array(editors.length).fill(false));
		}
	}, [selectedComponentPropsValue, childComp]);

	const toggleOpen = (idx) => {
		const newOpenList = [...openList];

		return () => {
			newOpenList[idx] = !openList[idx];
			setOpenList(newOpenList);
		};
	};

	if (!editorList.length) return null;
	return (
		<Flex
			sx={{ ...scrollBarStyle, ...{ gap: '8px' } }}
			overflow={'auto'}
			maxH={500}
			width={'100%'}
			borderRadius={'10px'}
			mt={1}
			flexWrap={'wrap'}
			ref={viewportRef}
		>
			<ViewportList viewportRef={viewportRef} items={editorList}>
				{(item, idx) => {
					return (
						<PropsEditorRow
							key={`props-row-${item.componentId}-${idx}`}
							{...{ ...item }}
							title={item?.props?.mzTitle}
							idx={idx}
							toggleOpen={toggleOpen(idx)}
							isOpen={openList[idx]}
						/>
					);
				}}
			</ViewportList>
		</Flex>
	);
};

export default PropsEditorBody;
